import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=13ff2476&"
import script from "./OrganisationSettings.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports